// TenantRights.js

export const TenantRightsContent = () => {
  return `
    <h2>Tenant Rights & Property Showings</h2>

    <div class="tenant-rights-explanation">
      <h3>Professional Property Showing Management</h3>
      <p>ShowingBooker is a professional property showing management system that ensures your legal rights are respected when your rental property is shown to potential buyers or renters. We provide legal notice (24+ hours advance notice) and full documentation of all showings.</p>

      <div class="rights-box">
        <h3>Your Rights as a Tenant</h3>
        <ul>
          <li>✓ Always get 24+ hours advance notice with all details - no more surprise visits or last-minute disruptions</li>
          <li>✓ All showings scheduled through secure online platform</li>
          <li>✓ Professional coordination and documentation</li>
          <li>✓ Your privacy and security protected</li>
        </ul>
      </div>

      <h3>California Civil Code Section 1954</h3>
      <p>24-Hour Notice Required: Landlords must give written notice at least 24 hours before entry (ShowingBooker provides proper notice)</p>

      <h3>How It Works</h3>
      <p>Accountability: Buyer's agents/buyers pay $10 per showing to the platform for compliance documentation and legal notices</p>

      <h3>Professional Service</h3>
      <p>ShowingBooker.com handles all the coordination professionally with a $10 service fee that is paid by the buyer's agent and/or buyer to the platform</p>

      <h3>Key Features</h3>
      <ul>
        <li>✓ Legal Compliance: Automatic 24+ hour advance notice (meeting CA Civil Code Section 1954 requirements)</li>
        <li>✓ Professional Documentation</li>
        <li>✓ Secure Scheduling</li>
        <li>✓ Privacy Protection</li>
      </ul>
    </div>
  `;
};

export default function TenantRights() {
  return (
    <div className="tenant-rights-page">
      <div dangerouslySetInnerHTML={{ __html: TenantRightsContent() }} />
    </div>
  );
}